import React, { useState } from 'react';
 
const Comment = ({comment = {}, lang, saveComment, handleCloseComment, statement}) => {
  const [ content, setContent ] = useState(comment.content)
  
  const handleChange = event => {
    setContent(event.target.value);
  }
  
  const handleOnSave = () => {
    saveComment({
      ...comment,
      content: content
    });
    handleCloseComment();
  }
 
  return (
    <div>
      <div class="modal-dialog comment-modal">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              onClick={ handleCloseComment }
            >
              &times;
            </button>
            <h4 class="modal-title">
              { `${lang.q360_comment_modal_title}:`  }
            </h4>
            <h4 class="modal-title statement-text">
              {statement.text}
            </h4>
          </div>
          <div class="modal-body comment-modal-body">
            <label>{ (lang.q360_comment_modal_label || '').toUpperCase() }</label>
            <textarea
              type="text"
              className="comment-text-input"
              rows="5"
              value={ content }
              autoFocus
              autoComplete="off"
              onChange={ handleChange }
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" onClick={ handleCloseComment }>
              { lang.q360_comment_modal_close }
            </button>
            <button type="button" class="btn comment-save-btn" onClick={ handleOnSave }>
              { lang.q360_comment_modal_save }
          </button>
          </div>
        </div>
      </div>
    </div>
  )
};
 
export default Comment;
